export default function giveWarning(message) {
  if (process.env.NODE_ENV !== 'production') {
    /* eslint-disable no-console */
    console.warn(message);
    /* eslint-enable no-console */
  }
}



// WEBPACK FOOTER //
// ./src/__utils/warning.js